import React, {useMemo} from 'react';

import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import {
	useGetBannerImagesQuery,
	useGetCategoriesListQuery,
	useGetNewsListQuery,
} from '../../redux/newsApi';
import {BannerImagesType, OneNewsTypes} from '../../types/TypesNews';
import CategoriesAndTags from './CategoriesAndTags';
import {useTranslation} from 'react-i18next';
import NewsListElement from './components/NewsListElement';
import NewsFilters from './components/NewsFilters';
import {useNewsFilters} from './hooks/useNewsFilters';
import MediaImageCarousel from './components/MediaImageCarousel';
import Loader from '../../assets/Animations/PreLoaderComponent/Loader';

const MediaAndNews: React.FC = () => {
	const {t} = useTranslation();
	const filters = useNewsFilters(() => {});

	const {data: newsResp, refetch: refetchNews} = useGetNewsListQuery({
		category_id: filters.currentCategory,
		month: filters.currentMonth,
		text: filters.currentText || null,
		tag_id: filters.currentTag,
	});

	const newsList = newsResp?.msg_list || null;

	// Update filters with refetch function
	const filtersWithRefetch = useMemo(
		() => ({
			...filters,
			handleClickLupa: async () => {
				await refetchNews();
				filters.setCurrentText('');
				filters.setOpenSearchInput(false);
			},
		}),
		[filters, refetchNews],
	);

	const {data: bannersResp, isLoading: isLoadingBanners} =
		useGetBannerImagesQuery('newslist');

	const bannerImages: BannerImagesType[] = bannersResp?.images ?? [];

	const {data: categoriesResp} = useGetCategoriesListQuery();
	const categoriesList = categoriesResp?.msg_categories || null;

	return (
		<div className="page__content">
			<TopTitleBlock title={'Новини'} />
			<div className="page__media-img media-img">
				{isLoadingBanners ? (
					<Loader size="large" />
				) : (
					<MediaImageCarousel banners={bannerImages} />
				)}
			</div>
			<div className="page__media-header media-header">
				<NewsFilters
					filters={filtersWithRefetch}
					categoriesList={categoriesList}
				/>
			</div>
			<div className="page__media-slider media-slider">
				<div className="media-slider__wrapper">
					<div className="media-slider__body">
						<div className="media-slider__slide">
							{newsList && newsList.length > 0 ? (
								newsList?.map((msg: OneNewsTypes) => {
									return (
										<NewsListElement
											key={msg.id}
											msg={msg}
											currentCategory={filters.currentCategory}
											currentTag={filters.currentTag}
											handleChangeListItem={filters.handleChangeListItem}
										/>
									);
								})
							) : (
								<div className="media-slider__title">
									{t('За даним запитом новини відсутні')}
								</div>
							)}
						</div>
					</div>
				</div>
				{/*<div className="media-slider__roll">
		                    <img src={media_roll} alt="roll"/></div>
		                <div className="media-slider__scroll"></div>*/}
			</div>
			<CategoriesAndTags handleChangeListItem={filters.handleChangeListItem} />
			{/*<div className="page__media-list media-list">
		                <div className="media-list__row">
		                    {tagsList &&
		                        <div className="media-list__tags ">
		                            <div className="tags-media__item">
		                                <div className="tags-media__top">
		                                    <div className="tags-media__title">{apiData?.text_tagsTitle}</div>
		                                    <div className="tags-media__icon">
		                                        <img src={tagsIcon} alt="tag_icon"/>
		                                    </div>
		                                </div>
		                                <div className="tags-media__row">
		                                    {tagsList?.map((tag: infoType) => {
		                                        return (
		                                            <div key={`tag${tag.id}`} className="tags-media__element">
		                                                <button onClick={()=>handleChangeListItem(tag.id,"tag")} className="tags-media__opportunities">{tag.name}</button>
		                                            </div>);
		                                    })}
		                                </div>
		                            </div>
		                        </div>
		                    }
		                    {categoriesList &&
		                        <div className="media-list__categories ">
		                            <div classname="categories-media__item">
		                                <div className="categories-media__top">
		                                    <div className="categories-media__title">
		                                        {apiData.text_categoriesTitle}</div>
		                                    <div className="categories-media__icon">
		                                        <img src={categories_icon} alt="categories_icon"/></div>
		                                </div>
		                                <div className="categories-media__row">
		                                    {categoriesList.map((category: infoType) => {
		                                        return (
		                                            <div key={`category${category.id}`} className="tags-media__element">
		                                                <button className="tags-media__opportunities" onClick={()=>
		                                                    handleChangeListItem(category.id,"category",category.name)}>
		                                                    {category.name}</button>
		                                            </div>
		                                        );
		                                    })}
		                                </div>
		                            </div>
		                        </div>
		                    }
		                </div>
		            </div>*/}
			{/*{fixedList && fixedList?.length > 0 &&
		                <div className="page__media-slider-bottom media-slider-bottom">
		                    <div className="media-slider-bottom__wrapper">
		                        <div className="media-slider-bottom__row">
		                            <MediaSlider list={fixedList}/>
		                        </div>
		                    </div>
		                </div>
		            }*/}
		</div>
	);
};

export default MediaAndNews;
